'use client';

import { usePathname } from "next/navigation";
import Image from 'next/image';

export function ICPFooter() {
  const pathname = usePathname();
  const showICP = !pathname.startsWith('/organoids');

  if (!showICP) return null;

  return (
    <footer className="bg-gradient-to-b from-slate-50 to-slate-100 border-t border-slate-200 py-3 text-center" suppressHydrationWarning>
      <div className="space-y-1 w-full">
        <p className="text-sm text-slate-500">
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-slate-700 transition-colors"
          >
            京 ICP 备 2026012059 号
          </a>
        </p>
        <p style={{ fontSize: '12px', color: '#94a3b8', display: 'inline-flex', flexDirection: 'row', alignItems: 'center', gap: '4px', margin: 0, padding: 0 }}>
          <Image
            src="/police-badge.png"
            alt="公安备案图标"
            width={14}
            height={14}
            style={{ flex: '0 0 auto', margin: 0, padding: 0, display: 'inline-block', verticalAlign: 'middle' }}
          />
          <span style={{ display: 'inline-block', verticalAlign: 'middle', lineHeight: 1 }}>
            <a 
              href="http://www.beian.gov.cn/portal/registerSystemInfo" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#94a3b8', textDecoration: 'none', whiteSpace: 'nowrap', fontSize: '12px' }}
            >
              京公网安备 11011302007858 号
            </a>
          </span>
        </p>
      </div>
    </footer>
  );
}